import { getTranslation } from '@easy-expense/intl-client';

/** Feature bullets for the Starter card on the web purchase ladder. */
export function starterPlanFeatures(): string[] {
  return [
    getTranslation('Unlimited receipt scanning'),
    getTranslation('Unlimited expense reports'),
    getTranslation('Email receipt forwarding'),
  ];
}

/** Feature bullets for the Individual Professional card, on top of Starter. */
export function professionalPlanFeatures(): string[] {
  return [
    getTranslation('Invite up to 2 others'),
    getTranslation('Connect bank accounts, cards, and email'),
    getTranslation('Unlimited workspaces'),
    getTranslation('Automatic mileage tracking'),
    getTranslation('Statement reconciliation'),
    getTranslation('Approval workflows'),
  ];
}

/** Feature bullets for the Team card, on top of Individual Professional. */
export function teamPlanFeatures(): string[] {
  return [getTranslation('Add unlimited seats'), getTranslation('Priority support')];
}
